import type { CardDefinition } from "../../domain/types/index.js";
import { REWARD_POOLS } from "../../content/rewardPools.js";

export type PoolSize = "small" | "medium" | "large";

export function flattenPool(pool: { workers: readonly string[]; actions: readonly string[] }): string[] {
  return [...new Set([...pool.workers, ...pool.actions])];
}

export function cardsForPoolSize(cards: readonly CardDefinition[], size: PoolSize): CardDefinition[] {
  const inDefault = new Set(flattenPool(REWARD_POOLS[size]));
  return cards.filter((card) => card.rewardTier === size || inDefault.has(card.id));
}
